import httpService from "../Api/http.service";

const fetchRegionByQueryParams = (partner_id, group_id, group_ids = [], canSelectMultipleGroups = false) => {
  const selectedGroupIds = group_ids.filter((id) => id !== 'ALL_GROUPS');
  const hasPartner = Boolean(partner_id && partner_id !== 'ALL_PARTNERS');

  let api = `/regions?`;

  if (hasPartner) {
    api += `partner_id=${partner_id}`;
  }

  const sep = hasPartner ? '&' : '';

  if (canSelectMultipleGroups && selectedGroupIds.length) {
    api += sep + selectedGroupIds.map((id) => `group_ids=${id}`).join('&');
  } else if (group_id && group_id !== 'ALL_GROUPS') {
    api += `${sep}group_id=${group_id}`;
  }

  return httpService({
    url: api,
    method: "get",
  });
};

const createRegion = (payload) =>
  httpService({
    url: `/region`,
    method: "post",
    data: payload,
  });

const updateRegion = (payload) =>
  httpService({
    url: `/region`,
    method: "put",
    data: payload,
  });

const deleteRegion = (payload) =>
  httpService({
    url: `/region`,
    method: "delete",
    data: payload,
  });

const regionService = {
  createRegion,
  updateRegion,
  deleteRegion,
  fetchRegionByQueryParams
};

export default regionService;
